import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'

const CheckBox = ({
    label,
    checked,
    onChange = () => {},
    disabled,
    style
}) => (
    <div style={style}>
        <Form.Check inline disabled={disabled} type='checkbox' label={label} checked={!!checked} onChange={e => onChange(Boolean(e.target.checked))} />
    </div>
)

export default CheckBox